import { messaging, isSupported } from './firebase-config';
import {
  getToken,
  deleteToken,
} from 'firebase/messaging';

// ✅ Utility function to check environment variables
const getEnvironmentVariable = (key, fallback = null) => {
  const value = process.env[key];

  // Debug logging removed

  return value || fallback;
};

// ✅ Use environment variable for VAPID key with fallback
const vapidKey = getEnvironmentVariable(
  'REACT_APP_FIREBASE_VAPID_KEY',
  'BBzoc3La_2DZ4aIIt49yJY9i10W6WtOSDRkE-C6T7NzY_u6Q4M8S2M1qVzFJ95mV9ydBfvYcFlSvGhH0HeszsSI'
);

// Debug logging removed

export const requestNotificationPermission = async () => {
  try {
    // Check if VAPID key is available
    if (!vapidKey) {
      return null;
    }

    const supported = await isSupported();
    if (!supported) {
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      return null;
    }

    const registration = await navigator.serviceWorker.ready;

    const token = await getToken(messaging, {
      vapidKey,
      serviceWorkerRegistration: registration,
    });

    // Token retrieved successfully
    return token;
  } catch (err) {
    // requestNotificationPermission error
    return null;
  }
};

// export const onMessageListener = () =>
//   new Promise(async (resolve) => {
//     const supported = await isSupported();
//     if (!supported) return;

//     onMessage(messaging, (payload) => {
//       console.log('📨 Foreground notification:', payload);
//       const { title, body } = payload.notification;

//       toast.info(
//         <>
//           <strong>{title}</strong>
//           <div>{body}</div>
//         </>
//       );

//       try {
//         const audio = new Audio('/notif.mp3');
//         audio.play();
//       } catch (err) {
//         console.warn('🔇 Audio play failed:', err.message);
//       }

//       resolve(payload);
//     });
//   });

export const clearFCMToken = async () => {
  try {
    const supported = await isSupported();
    if (!supported) return;

    const registration = await navigator.serviceWorker.getRegistration();

    const deleted = await deleteToken(messaging, {
      serviceWorkerRegistration: registration,
      vapidKey,
    });

    // console.log('🧹 FCM Token deleted:', deleted);
    return deleted;
  } catch (err) {
    // Failed to clear token
    return false;
  }
};
